import React from "react";
import { Menu, Icon, Button, Header, Modal } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import MPMContext from "mpm-config/context/MPMContext";
import { useState } from "react";
import moment from  "moment";
import { Link } from "react-router-dom";

const DisconnectModal = () => {
  const context = React.useContext(MPMContext);
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);
  return (
    <Modal
      open={open}
      trigger={
        <Menu.Item as="a" icon={true} onClick={() => setOpen(true)}>
          <Icon name="power off" color="blue" size="large" />
        </Menu.Item>
      }
      basic
      size="small"
      onClose={() => setOpen(false)}
    >
      <Header
        icon="power off"
        content={<FormattedMessage id="label.logout-header" />}
      />
      <Modal.Content>
        <p>
          <FormattedMessage id="label.logout-description" />
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button basic color="red" inverted onClick={close}>
          <Icon name="remove" /> <FormattedMessage id="label.no" />
        </Button>
        <Button color="green" inverted onClick={context.logout}>
          <Icon name="checkmark" /> <FormattedMessage id="label.yes" />
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

class TopMenu extends React.Component {
  state ={
    bigMenu : true
  }
  handleMenuClick = () => {
    let sideMenu = document.getElementById("side-menu");
    if(sideMenu.classList.contains("big")){
      sideMenu.classList.remove("big");
      sideMenu.classList.add("small");
    }else{
      sideMenu.classList.add("big");
      sideMenu.classList.remove("small");
    }
    this.setState({
      bigMenu: !this.state.bigMenu
    })
  }
  render() {
    return (
      <div className="top-menu">
        <Menu>
          <Menu.Item
            as={Button}
            onClick={this.handleMenuClick}
            icon={`${
              this.state.bigMenu ? "angle double left" : "angle double right"
            }`}
          />
          <Menu.Item>
            <FormattedMessage id="welcome" />
            <span className="menu-user">
              {this.context.connectedUser.nom}{" "}
              {this.context.connectedUser.prenom}
            </span>
          </Menu.Item>
          <Menu.Item>
            <FormattedMessage id="label.lastconnexion" />
            <span className="menu-user">
              {moment(this.context.connectedUser.lastConnexion).format("DD/MM/YYYY HH:mm:ss")}
            </span>
          </Menu.Item>
          <Menu.Menu position="right">

            <Menu.Item as={Link} icon={true} to="/profile/settings">
              <Icon name="user" color="grey" />
            </Menu.Item>
            <DisconnectModal />
          </Menu.Menu>
        </Menu>
      </div>
    );
  }
}
TopMenu.contextType = MPMContext;
export default TopMenu;
